<template>
	<div>
		<div class="d-flex justify-content-center py-4" v-if="isLoading">
			<loader/>
		</div>
		<notification-message
			message="Parece que aún no agregas a tus partners"
			v-if="partners=='' && !this.isLoading"
		/>
		<div class="main-content-container container-fluid px-4">

      <div class="page-header row no-gutters py-4" v-if="!isLoading">
        <div class="col-12 col-sm-6 text-center text-sm-left mb-4 mb-sm-0">
          <span class="text-uppercase page-subtitle">Visión general</span>
          <h3 class="page-title">Partners</h3>
        </div>
        <div class="col-12 col-sm-6 d-flex align-items-center">
          <div class="d-none d-md-inline-flex mb-sm-0 mx-auto ml-sm-auto mr-sm-0" role="group" aria-label="Page actions">
            <router-link to="agregar/partner" id="add-new-event" class="btn btn-primary">
              <i class="fas fa-plus"></i> 
              Partner 
            </router-link>
          </div>
        </div>
      </div>

			<div class="row">
				<div v-for="(item, index) of partners" class="col-lg-3 col-md-6 col-sm-12 mb-4">
					<router-link :to="'/partner/' + item.name">
						<div class="card card-small card-post card-post--1">
							<div class="card-body text-center">
								<img :src="item.icon" class="img-fluid"/>
							</div>
							<div class="card-footer border-top text-primary">
								<span class="badge badge-secondary mr-2" @click.prevent="deleteOption(item.id, index)">
									<i class="fas fa-trash"/>
								</span>
								<span class="badge badge-secondary"><i class="fas fa-edit"></i></span>
							</div>
						</div>
					</router-link>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import NotificationMessage from '@/components/general/NotificationMessage';
	import axios from 'axios'
	export default {
		components: {
			NotificationMessage
		},
		data() {
			return {
				isLoading: true,
				partners: []
			}
		},

		mounted() {
			this.getPartners();
		},

		methods: {
			getPartners() {
				axios.get(`${process.env.VUE_APP_ROOT_API}/partner`)
					.then(response => {
						if(response.status == 200) {
							this.partners = response.data;
							this.isLoading = false;
						}
					})
					.catch(err => {
						console.log(err);
					});
			},

			deleteOption(id, index) {
				const message = '¿Quieres eliminar este partner?';
				const options = {
					okText: 'Sí',
					cancelText: 'No'
				};
				let that = this;
				this.$dialog
					.confirm(message, options)
					.then(function(dialog) {
						that.deletePartner(id, index);
					});
			},

			async deletePartner(id, index) {
				const url = `${process.env.VUE_APP_ROOT_API}/partner/${id}`;
				const settings = {
					method: 'DELETE'
				};
				const response = await fetch(url, settings);
					if(response.status == 200) {
					this.partners.splice(index, 1);
				}
			}
		}
	}
</script>